import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcNotebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 204,
	height: 247,
	viewBox: "0 0 204 247",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.9259 3C37.7848 3 34.4277 6.35703 34.4277 10.4981V236.036C34.4277 240.177 37.7848 243.535 41.9259 243.535H184.613C188.754 243.535 192.111 240.177 192.111 236.036V63H198C201.313 63 204 60.3137 204 57V11C204 6.58172 200.418 3 196 3H184.613H184H41.9259Z",
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 7,
			width: 157,
			height: 234,
			rx: 7.49814,
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			width: 170,
			height: 247,
			rx: 7.49814,
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 7.49814C4 3.35703 7.35703 0 11.4981 0H26V247H11.4981C7.35703 247 4 243.643 4 239.502V7.49814Z",
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157 198L8 198C3.58173 198 3.13124e-07 194.418 6.99382e-07 190L4.80825e-06 143C5.19451e-06 138.582 3.58173 135 8.00001 135L157 135L157 198Z",
			fill: "#B6AFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 48C42 35.2975 52.2975 25 65 25H131C143.703 25 154 35.2975 154 48C154 60.7025 143.703 71 131 71H65C52.2975 71 42 60.7025 42 48Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107 165L157 119L157 211L107 165Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157 135H191C195.418 135 199 138.582 199 143V190C199 194.418 195.418 198 191 198H157V135Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115 84L119 64H136.5L115 84Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 48C42 35.2975 52.2975 25 65 25H131C143.703 25 154 35.2975 154 48C154 60.7025 143.703 71 131 71H65C52.2975 71 42 60.7025 42 48Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 71,
			cy: 48,
			r: 4,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 97,
			cy: 48,
			r: 4,
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 123,
			cy: 48,
			r: 4,
			fill: "#D9D9D9"
		})
	]
});
export default SvgIcNotebook;
